export interface FavoriteArtistFilterType {
  onlyFavorite: boolean
}

export const initialFavoriteArtistFilter: FavoriteArtistFilterType = {
  onlyFavorite: false
};